module.exports = __webpack_public_path__ + "img/组织结构.4b8e4819.png";